/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.14.1-13-ge76df34-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OtpLoginRequest interface.
 */
export function instanceOfOtpLoginRequest(value) {
    if (!('otp' in value) || value['otp'] === undefined)
        return false;
    return true;
}
export function OtpLoginRequestFromJSON(json) {
    return OtpLoginRequestFromJSONTyped(json, false);
}
export function OtpLoginRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'otp': json['otp'],
    };
}
export function OtpLoginRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'otp': value['otp'],
    };
}
